import React, { useState } from 'react';
import { IProperty } from '../../utils/JsonApiRequest';
import AvailableFrom from './AvailableFrom';
import PropertyDescription from './PropertyDescription';
import Address from './Address';
import LoginRegister from './LoginRegister';
import Files, { IFilesProps } from './Files';
import { IPropertyWizardInput } from './NewPropertyWizard';
import Contact from './Contact';
import HouseSvg from '../Valuation/HouseSvg';
import ApartmentSvg from '../Valuation/ApartmentSvg';
// import import('../../assets/img/Lukas/Bild1.jpg') from '../../assets/img/lukas01.jpg';
import Publish from './Publish';
import { ICarport } from '../../interfaces/IHome';
import { IEditProperty } from './EditProperty';

// type IPropertyAdd = 'price_utilities';

interface IUsedBy {
    property_type?: Array<IProperty['property_type']>;
    type_of_marketing?: Array<IProperty['type_of_marketing']>;
    price_label?: Array<IProperty['price_label']>;
    import_id?: boolean;
    commissionable?: boolean;
    group_parent_id?: boolean;
}

export interface IStep {
    name:
    | keyof IEditProperty
    | 'start'
    | 'rentPrice'
    | 'buyCommission'
    | 'availableFrom'
    | 'features'
    | 'carports'
    | 'files'
    | 'files_floor_plan'
    | 'loggedIn'
    | 'contact'
    | 'saveContactInProfile';
    trackingName?: string;
    title: string;
    shortTitle?: string; // for Valuation2Property
    label?: string;
    // image?: string;
    image?: Promise<typeof import('*.jpg')>;
    required?: boolean;
    component?: React.FC<React.PropsWithChildren<IPropertyWizardInput>>;
    fileComponent?: React.FC<React.PropsWithChildren<IFilesProps>>;
    description?: string;
    unit?: string;
    usedBy?: IUsedBy;
    isLast?: boolean;
    isValid?: (val: number | string) => boolean;
    validHint?: string;
    decimalScale?: number; // Nachkommastellen für numberFormat, nicht nötig bei unit='€'
    options?: Record<string, string>;
    images?: Record<string, React.ReactNode>;
    inputs?: Array<{
        name: keyof IEditProperty;
        title: string;
        // label?: string;
        unit?: string;
        options?: Record<string, string>;
        type?: 'number' | 'boolean' | 'text' | 'html';
        hideOn?: keyof IEditProperty;
        showOn?: keyof IEditProperty;
        defaultValue?: string;
        isValid?: (val: number | string) => boolean;
        validHint?: string;
        decimalScale?: number; // Nachkommastellen für numberFormat, nicht nötig bei unit='€'
    }>;
    // options?: { [key in ICode]: { [key: string]: string } };
    features?: Record<string, string>;
    carports?: Array<{
        count: number;
        type: ICarport;
        price_rent: number; // 0-10000000
        price_buy: number; // 0-10000000
    }>;
    // hasOwnForm?: boolean;
}

// const id2feature = {
//     '21': 'WG geeignet',
//     '23': 'Einbauküche',
//     '24': 'Aufzug',
//     '25': 'Garage/ Stellplatz',
//     '26': 'Garten/ -mitbenutzung',
//     '27': 'Balkon/ Terrasse',
//     '28': 'möbliert',
//     '29': 'barrierefrei',
//     '30': 'Keller',
//     '31': 'Dachboden',
//     '32': 'Gäste WC',
//     '33': 'Einliegerwohnung',
//     '34': 'derzeit vermietet',
//     '35': 'Wohnberechtigungsschein (WBS) benötigt',
//     '36': 'Haustiere erlaubt',
//     '37': 'Denkmalschutz',
// };

// const houseFeatures = ['29', '28', '27', '26', '30', '31'];
// const apartmentFeatures = ['27', '26', '29', '28', '23', '30', '31'];

/* Moin! Ich bin Lukas und ich helfe Dir beim Upload Deiner Immobilie. */

const steps: Array<IStep> = [
    {
        name: 'start',
        trackingName: 'start',
        title: 'Moin! Ich bin Lukas und ich helfe Dir beim Upload Deiner Immobilie.',
        shortTitle: '',
        description: 'Halte hierfür alle wesentlichen Informationen (Adresse, Anzahl Zimmer, Wohnfläche, Bilder, etc...) zu deiner Immobilie bereit.',
        image: import('../../assets/img/Lukas/Bild1.jpg'),
    },

    {
        name: 'property_type_parent_name',
        trackingName: 'immobilienart',
        title: 'Nice! Welche Art von Immobilie möchtest Du inserieren?',
        shortTitle: 'Immobilienart',
        image: import('../../assets/img/Lukas/Bild2.jpg'),
        required: true,
        options: {
            apartment: 'Wohnung',
            house: 'Haus',
            // commercial: 'Gewerbe\u00ADimmobilie', // Gewerbe(-)immobilie
        },
        images: {
            house: <HouseSvg variant="house" />,
            apartment: <ApartmentSvg variant="apartment" />,
            commercial: <HouseSvg variant="house" />,
        },
    },
    {
        name: 'type_of_marketing',
        trackingName: 'vermarktungsart',
        title: 'Okay! Geht es um eine Mietwohnung oder möchtest Du verkaufen?',
        shortTitle: 'Vermarktungsart',
        image: import('../../assets/img/Lukas/Bild3.jpg'),
        required: true,
        options: {
            rent: 'Vermietung',
            buy: 'Verkauf',
            rent_waz: 'Wohnen auf Zeit',
        },
        usedBy: { property_type: ['apartment'] },
    },
    {
        name: 'type_of_marketing',
        trackingName: 'vermarktungsart',
        title: 'Möchtest Du ein Haus vermieten oder verkaufen?',
        shortTitle: 'Vermarktungsart',
        image: import('../../assets/img/Lukas/Bild2.jpg'),
        required: true,
        options: {
            buy: 'Verkauf',
            rent: 'Vermietung',
            rent_waz: 'Wohnen auf Zeit',
        },
        usedBy: { property_type: ['house'] },
    },
    {
        name: 'type_of_marketing',
        trackingName: 'vermarktungsart',
        title: 'Möchtest Du die Gewerbeimmobilie vermieten oder verkaufen?',
        shortTitle: 'Vermarktungsart',
        image: import('../../assets/img/Lukas/Bild2.jpg'),
        required: true,
        options: {
            buy: 'Verkauf',
            rent: 'Vermietung',
        },
        usedBy: { property_type: ['commercial'] },
    },
    {
        name: 'rentPrice',
        trackingName: 'preis',
        title: 'Alles klar! Bitte gib hier den Mietpreis {typeOf} an.',
        shortTitle: 'Mietpreis',
        image: import('../../assets/img/Lukas/Bild4.jpg'),
        // description: '###',
        inputs: [
            {
                name: 'price_label',
                title: '',
                options: {
                    kaltmiete: 'Kaltmiete',
                    // warmmiete: 'Warmmiete',
                    pauschalmiete: 'Pauschalmiete',
                },
            },
            {
                name: 'price',
                title: 'Mietpreis',
                unit: '€',
                isValid: (nr: number) => Number.isInteger(nr * 100) && nr >= 0 && nr <= 100000,
                validHint: 'Bitte nur Werte zwischen 0 und 100.000 verwenden.',
            },
        ],
        usedBy: { type_of_marketing: ['rent', 'rent_waz'] },
    },
    {
        name: 'price_utilities',
        trackingName: 'nebenkosten',
        title: 'Hier kannst Du die Nebenkosten Deiner Immobilie angeben!',
        shortTitle: 'Nebenkosten',
        image: import('../../assets/img/Lukas/Bild4.jpg'),
        unit: '€',
        // description: '###',
        // inputs: { price_label: 'Preisart', price: 'Preis' },
        usedBy: { type_of_marketing: ['rent', 'rent_waz'], price_label: ['kaltmiete'] },
        inputs: [
            {
                name: 'price_utilities',
                title: 'Nebenkosten',
                unit: '€',
                isValid: (nr: number) => Number.isInteger(nr * 100) && nr >= 0 && nr <= 100000,
                validHint: 'Bitte nur Werte zwischen 0 und 100.000 verwenden.',
            },
            { name: 'price_heating_included', title: 'Heizkosten in Nebenkosten enthalten', type: 'boolean' },
            {
                name: 'price_heating',
                title: 'Heizkosten',
                unit: '€',
                hideOn: 'price_heating_included',
                isValid: (nr: number) => Number.isInteger(nr * 100) && nr >= 0 && nr <= 100000,
                validHint: 'Bitte nur Werte zwischen 0 und 100.000 verwenden.',
            },
        ],
    },
    {
        name: 'kaution',
        trackingName: 'kaution',
        title: 'Wie hoch ist die Kaution?',
        shortTitle: 'Kaution',
        label: 'Kaution',
        image: import('../../assets/img/Lukas/Bild5.jpg'),
        unit: '€',
        isValid: (nr: number) => Number.isInteger(nr * 100) && nr >= 0 && nr <= 300000,
        validHint: 'Bitte nur Werte zwischen 0 und 300.000 verwenden.',
        usedBy: { type_of_marketing: ['rent', 'rent_waz'] },
    },
    {
        name: 'price',
        trackingName: 'preis',
        title: 'Alles klar! Bitte gib hier den Kaufpreis {typeOf} an.',
        shortTitle: 'Kaufpreis',
        image: import('../../assets/img/Lukas/Bild4.jpg'),
        // unit: '€',
        usedBy: { type_of_marketing: ['buy'] },
        inputs: [
            { name: 'kaufpreis_auf_anfrage', title: 'Kaufpreis auf Anfrage', type: 'boolean' },
            {
                name: 'price',
                title: 'Kaufpreis',
                unit: '€',
                hideOn: 'kaufpreis_auf_anfrage',
                isValid: (nr: number) => Number.isInteger(nr * 100) && nr >= 0 && nr <= 99999999,
                validHint: 'Bitte nur Werte zwischen 0 und 99.999.999 verwenden.',
            },
        ],
    },
    {
        name: 'buyCommission',
        trackingName: 'provision',
        title: 'Gibt es eine Provision?',
        shortTitle: 'Provision',
        description: 'Falls Du Makler bist: Setze einen Haken. Sonst bitte überspringen!',
        image: import('../../assets/img/Lukas/Bild5.jpg'),
        inputs: [
            { name: 'commissionable', title: 'Provisionspflichtig', type: 'boolean' },
            { name: 'commission', title: 'Courtage', type: 'text', showOn: 'commissionable', defaultValue: '3,57 % inkl. gesetzl. MwSt.' },
            // { name: 'commission_note', title: 'Ergänzende Angaben zur Courtage', type: 'html' },
        ],
        usedBy: { type_of_marketing: ['buy'] },
    },
    {
        name: 'hausgeld',
        trackingName: 'hausgeld',
        title: 'Wie hoch ist das Hausgeld?',
        shortTitle: 'Hausgeld',
        image: import('../../assets/img/Lukas/Bild2.jpg'),
        label: 'Hausgeld',
        unit: '€',
        isValid: (nr: number) => Number.isInteger(nr * 100) && nr >= 0 && nr <= 100000,
        validHint: 'Bitte nur Werte zwischen 0 und 100.000 verwenden.',
        usedBy: { type_of_marketing: ['buy'], property_type: ['apartment'] },
    },
    {
        name: 'living_area',
        trackingName: 'wohnflaeche',
        title: 'Wie groß ist {yourType}?',
        shortTitle: 'Wohnfläche',
        image: import('../../assets/img/Lukas/Bild13.jpg'),
        label: 'Wohnfläche',
        unit: 'm²',
        isValid: (nr: number) => Number.isInteger(nr * 100) && nr >= 0 && nr <= 9999,
        validHint: 'Bitte nur Werte zwischen 0 und 9999 verwenden.',
        decimalScale: 2,
        usedBy: { property_type: ['apartment', 'house'] },
    },
    {
        name: 'total_area',
        trackingName: 'gesamtflaeche',
        title: 'Wie groß ist Gesamtfläche {typeOf}?',
        shortTitle: 'Gesamtfläche',
        image: import('../../assets/img/Lukas/Bild13.jpg'),
        label: 'Gesamtfläche',
        unit: 'm²',
        isValid: (nr: number) => Number.isInteger(nr * 100) && nr >= 0 && nr <= 9999,
        validHint: 'Bitte nur Werte zwischen 0 und 9999 verwenden.',
        decimalScale: 2,
        usedBy: { property_type: ['commercial'] },
    },
    {
        name: 'plot_area',
        trackingName: 'grundstuecksflaeche',
        title: 'Wie groß ist die Grundstücksfläche {typeOf}?',
        shortTitle: 'Grundstücksfläche',
        image: import('../../assets/img/Lukas/Bild13.jpg'),
        label: 'Grundstücksfläche',
        unit: 'm²',
        isValid: (nr: number) => Number.isInteger(nr * 100) && nr >= 0 && nr <= 9999,
        validHint: 'Bitte nur ganze Werte zwischen 0 und 9999 verwenden.',
        decimalScale: 2,
        usedBy: { property_type: ['house'] },
    },
    {
        name: 'chamber_count',
        trackingName: 'anzahl_zimmer',
        title: 'Wie viele Zimmer hat {theType}?',
        shortTitle: 'Anzahl Zimmer',
        image: import('../../assets/img/Lukas/Bild7.jpg'),
        label: 'Anzahl Zimmer',
        isValid: (nr: number) => Number.isInteger(nr * 2) && nr >= 0 && nr <= 99,
        validHint: 'Bitte nur ganze  und *,5 Werte zwischen 0 und 99 verwenden.',
        decimalScale: 1,
    },
    // {
    //     name: 'bedroom_count',
    //     title: 'Anzahl Schlafzimmer',
    // },
    // {
    //     name: 'bathroom_count',
    //     title: 'Anzahl Badezimmer',
    // },
    {
        name: 'availableFrom',
        trackingName: 'bezugsfrei_ab',
        title: 'Ab wann ist {theType} bezugsfrei?',
        shortTitle: 'Bezugsfrei ab',
        image: import('../../assets/img/Lukas/Bild6.jpg'),
        component: AvailableFrom,
        inputs: [
            {
                name: 'available_from_text',
                title: 'Bezugsfrei ab',
                options: {
                    '': 'Nicht festgelegt/ausgewählt',
                    sofort: 'sofort',
                    'nach Vereinbarung': 'nach Vereinbarung',
                    date: 'Datum',
                    // text: 'Freier Text',
                },
            },
        ],
    },
    {
        name: 'baujahr',
        trackingName: 'baujahr',
        title: 'Kennst Du das Baujahr? Ungefähr reicht auch!',
        shortTitle: 'Baujahr',
        image: import('../../assets/img/Lukas/Bild9.jpg'),
        label: 'Baujahr',
        // description: 'Falls Dir das genaue Baujahr nicht bekannt ist, reicht mir auch eine ungefähre Angabe.',
    },
    {
        name: 'features',
        trackingName: 'ausstattung',
        title: 'So, nun noch ein paar Fakten zur Ausstattung.',
        shortTitle: 'Ausstattung',
        image: import('../../assets/img/Lukas/Bild14.jpg'),
        features: {
            // '21': 'WG geeignet',
            // '23': 'Einbauküche',
            // '24': 'Aufzug',
            // '25': 'Garage/ Stellplatz',
            // '26': 'Garten/ -mitbenutzung',
            '26': 'Garten',
            '27': 'Balkon/ Terrasse',
            '28': 'möbliert',
            // '29': 'barrierefrei',
            '30': 'Keller',
            '31': 'Dachboden',
            // '32': 'Gäste WC',
            // '33': 'Einliegerwohnung',
            // '34': 'derzeit vermietet',
            // '35': 'Wohnberechtigungsschein (WBS) benötigt',
            // '36': 'Haustiere erlaubt',
            // '37': 'Denkmalschutz',
        },
        usedBy: { property_type: ['house'] },
    },
    {
        name: 'features',
        trackingName: 'ausstattung',
        title: 'So, nun noch ein paar Fakten zur Ausstattung.',
        shortTitle: 'Ausstattung',
        image: import('../../assets/img/Lukas/Bild14.jpg'),
        features: {
            // '21': 'WG geeignet',
            '23': 'Einbauküche',
            // '24': 'Aufzug',
            // '25': 'Garage/ Stellplatz',
            // '26': 'Garten/ -mitbenutzung',
            '26': 'Garten',
            '27': 'Balkon/ Terrasse',
            '28': 'möbliert',
            // '29': 'barrierefrei',
            '30': 'Keller',
            '31': 'Dachboden',
            // '32': 'Gäste WC',
            // '33': 'Einliegerwohnung',
            // '34': 'derzeit vermietet',
            // '35': 'Wohnberechtigungsschein (WBS) benötigt',
            // '36': 'Haustiere erlaubt',
            // '37': 'Denkmalschutz',
        },
        usedBy: { property_type: ['apartment'] },
    },
    {
        name: 'field_address',
        trackingName: 'adresse',
        title: 'Gib hier bitte die Adresse {typeOf} an.',
        shortTitle: 'Addresse',
        image: import('../../assets/img/Lukas/Bild11.jpg'),
        required: true,
        component: Address,
    },
    {
        name: 'objektbeschreibung',
        trackingName: 'beschreibung',
        title: 'Zielgerade: Bitte beschreibe Lage, Ausstattung und Zustand.',
        shortTitle: 'Beschreibung',
        image: import('../../assets/img/Lukas/Bild15.jpg'),
        component: PropertyDescription,
    },
    {
        name: 'files',
        trackingName: 'bilder_dateien',
        title: 'Lade hier Bilder der Immobilie hoch!',
        shortTitle: 'Bilder',
        image: import('../../assets/img/Lukas/Bild13.jpg'),
        fileComponent: Files,
    },
    {
        name: 'files_floor_plan',
        trackingName: 'grundriss_dateien',
        title: 'Lade hier den/die Grundriss/e der Immobilie hoch!',
        shortTitle: 'Grundriss',
        image: import('../../assets/img/Lukas/Bild13.jpg'),
        fileComponent: Files,
    },
    {
        name: 'loggedIn',
        trackingName: 'login_register',
        title: 'Bitte melde Dich an oder registriere Dich!',
        shortTitle: 'Login',
        image: import('../../assets/img/Lukas/Bild14.jpg'),
        required: true,
        component: LoginRegister,
        // hasOwnForm: true
    },
    // { name: 'contact', title: 'Kontaktdaten', description: 'Deine Kontaktdaten für Interessenten', component: Contact },
    {
        name: 'moderation_state',
        trackingName: 'inserieren_oder_vorschau',
        title: 'Top, nur noch ein letzter Schritt!',
        shortTitle: 'Veröffentlichen',
        image: import('../../assets/img/Lukas/Bild15.jpg'),
        component: Publish,
        // options: { exclusively_published: 'Exklusiv veröffentlichen', published: 'Regulär veröffentlichen', draft: 'Als Entwurf speichern' },
        isLast: true,
    },
];

export default steps;
